<template>
    <div class="password-input">
        <AccountInput
            :errorMessage="errorMessage"
            :name="name"
            @inputErrorDetected="emit('inputErrorDetected', name, errorMessage)"
        >
            <div class="password-input__container">
                <input
                    :type="inputType"
                    v-model="passwordValue"
                    :id="name"
                    :placeholder="placeholder ?? 'Heslo'"
                    :autocomplete="autocompleteOff ? 'off' : null"
                    ref="inputRef"
                    @keyup="inputKeyUp"
                />
                <KasaIcon
                    v-if="showEyeIcon"
                    name="eye"
                    :width="20"
                    :height="20"
                    class="password-input__input-icon"
                    @click="showPassword"
                ></KasaIcon>
            </div>
        </AccountInput>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, nextTick } from "vue";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import AccountInput from "./account-input.vue";

const emit = defineEmits<{
    /* eslint-disable @typescript-eslint/naming-convention */
    "update:modelValue": [newValue: string];
    inputKeyUp: [event: KeyboardEvent];
    inputErrorDetected: [fieldName: string, errorMessage: string];
}>();

const props = defineProps<{
    modelValue: string;
    name: string;
    placeholder?: string;
    autocompleteOff?: boolean;
    showEyeIcon?: boolean;
    focus?: boolean;
}>();

const errorMessage = defineModel<string>("errorMessage");

const passwordValue = computed({
    get() {
        return props.modelValue;
    },
    set(passwordValue) {
        errorMessage.value = null;
        emit("update:modelValue", passwordValue);
    },
});

const eyeActive = ref(false);
const showPassword = async () => {
    eyeActive.value = !eyeActive.value;
};

const inputType = computed(() => (eyeActive.value ? "text" : "password"));

const inputKeyUp = (event: KeyboardEvent) => {
    emit("inputKeyUp", event);
};

const checkIfIsValid = (silentCheck?: boolean): boolean => {
    let isValid = true;

    if (!passwordValue.value) {
        if (!silentCheck) {
            errorMessage.value = "Zadejte prosím svoje heslo.";
        }
        isValid = false;
    }

    nextTick(() => {
        if (errorMessage.value) emit("inputErrorDetected", props.name, errorMessage.value);
    });

    return isValid;
};

const inputRef = ref<HTMLInputElement>(null);
onMounted(() => {
    console.log("focus", props.focus);
    if (props.focus) {
        inputRef.value.focus();
    }
});

defineExpose({
    checkIfIsValid,
});
</script>
